// extracted by mini-css-extract-plugin
export default {"root":"SocialLinks_root__phhDV","link":"SocialLinks_link__W5nrG","icon":"SocialLinks_icon__ng7RW","copied":"SocialLinks_copied__xYrbR"};